import styled from '@emotion/styled';
import { Alert } from '@lightspeed/flame/Alert';

export const StyledAlert = styled(Alert)`
  border-top: 0px;
`;
